import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { SharedModule } from "../../../../@commons/ui-components/shared.module";

@Component({
  selector: 'vw-need-item',
  imports: [
    SharedModule
  ],
  templateUrl: './need-item.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './need-item.component.scss'
})
export class NeedItemComponent {
  @Input() label: string | number;
  @Input() iconUrl: string;
}
